import { useReframe } from 'nike-re-framejs';
import React from 'react';
import { makeField } from 'nike-form-js';

function ReadOnly({ children, form, path, label, hint, defaultValue = '', onClick, add }) {
    const { deref } = useReframe();
    const value = path ? deref(makeField(form, path).getValue()) || defaultValue : defaultValue;
    return (
        <div className="nike-input" onClick={onClick}>
            <div className="nike-input-label">{label}</div>
            {hint ? <div className="nike-input-hint">{hint}</div> : null}
            <div className="read-only">
                {value}
                {children}
            </div>
            {add}
        </div>
    );
}

export default ReadOnly;
